// Zero-dependency for the same reason as photoQueueDb.ts; the name lives in src/lib/storeNames.ts.
export const IDENTIFY_QUEUE_STORE = 'jobs';
export const IDENTIFY_QUEUE_VERSION = 1;
